import React from 'react';
import MergeModalStyled from './MergeModalStyled';
import { Button } from '@material-ui/core';
import { useIntl } from 'umi';

const MergeModal = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  return (
    <MergeModalStyled>
      <div className="merge-btn-content">
        {/* 会员卡号 */}
        {formatMessage({ id: 'adjustment.merge.n01.lbl12' })}
        <span className="content-merge">
          {/* 合并后不可逆，被合并的卡号将被注销 */}
          {formatMessage({ id: 'adjustment.merge.n01.lbl13' })}
        </span>
      </div>
      <div className="merge-btn-content">
        {/* 您确定要合并会员卡号吗？ */}
        {formatMessage({ id: 'adjustment.merge.n01.lbl14' })}
      </div>
      <div className="btn-wrap">
        <Button onClick={props.handleMergeCancel}>
          {/* 取消 */}
          {formatMessage({ id: 'comm.action.btn.08' })}
        </Button>
        <Button onClick={props.onConfirm}>
          {/* 确定 */}
          {formatMessage({ id: 'adjustment.merge.n01.lbl15' })}
        </Button>
      </div>
    </MergeModalStyled>
  );
};

export default MergeModal;
